/** @format */

import React, { useEffect, useState } from "react";
import LazyLoad from "react-lazyload";
import Image from "next/image";
import { enquireScreen } from "enquire-js";
// import { enquireScreen } from "enquire-js";
// import { footerNav, footerSocialNav, footerText } from "./LazyImage.helper";
import module_style from "./LazyImage.module.css";

const LazyImage = ({
  src,
  srcMob,
  alt,
  className = "relative",
  onError = false,
  from = ''
}) => {
  const refPlaceholder = React.useRef();
  const refImage = React.useRef();
  const refDeskImage = React.useRef();
  const refMobImage = React.useRef();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(()=>{
    enquireScreen((status) => setIsMobile(status));
  }, []);

  const removePlaceholder = () => {
    refPlaceholder.current.remove();
  };

  const removeErrorholder = () => {
    if (onError && refImage.current.src !== onError) {
      refImage.current.src = onError;
      refDeskImage.current.srcset = onError;
      refMobImage.current.srcset = onError;
      setTimeout(refPlaceholder.current.remove(), 1000);
    } else {
      refPlaceholder.current.remove();
    }
  };

  return (
    <div className={`${module_style.container} ${className}`}>
      {/*<div className={module_style.placeholder} ref={refPlaceholder} />*/}
      {window.location.pathname === '/' && from !== 'sellerusp' && from !== "hotthisweek" && from !== "trendsHomePage"
        ? null :
        <div className={module_style.placeholder} ref={refPlaceholder} />
      }
      <LazyLoad offset={1000} height={200} true>
        {window.location.pathname === '/' && from !== 'sellerusp' && from !== "hotthisweek" && from !== "trendsHomePage"
        ?
          <div className="home-components-image-wrap">
            <Image
            src={src}
            className={module_style.image}
            alt={alt}
            fill
            // sizes="(max-width: 768px) 100vw,
            //   (max-width: 1200px) 50vw,
            //   33vw
            // "
            style={{
              maxWidth: "100%",
              // height: "auto",
              // width: "auto",
              objectFit: "cover"
            }} />
          </div>
        :
          <picture>
            <source srcSet={src} media="(min-width: 768px)" ref={refDeskImage} />
            <source srcSet={srcMob} media="(min-width: 0px)" ref={refMobImage} />
            <img
              onLoad={removePlaceholder}
              onError={removeErrorholder}
              src={src}
              alt={alt}
              className={module_style.image}
              ref={refImage}
            />
          </picture>
        }
      </LazyLoad>
    </div>
  );
};
export default LazyImage;
